// ** 封装axios 拦截器 *
import axios from "axios"
import router from "@/router"
import ElementUI from 'element-ui';

import apiCfg from "../../config"

//创建实例封装url
const http = axios.create({
  timeout: 5000,
  baseURL: apiCfg.portalApi
})

// 请求拦截器
http.interceptors.request.use(
  config => {
    let token = sessionStorage.getItem('token')
    //请求头加token
    config.headers.token = token
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//响应拦截器
http.interceptors.response.use((response) => {
  return response;
}, (error) => {
  // 对响应错误做点什么
  if (error.response.status == 401) {
    router.push("/login")
  }
  if (error.response.status == 400) {
    ElementUI.Message({
      title: '警告',
      message: error.response.data.message,
      type: 'error',
      showClose: true,
      duration: 5000
    });
  }
  console.log(error.response.data.message)
  return Promise.reject(new Error(error.response.data.message))
});

export default {
  get: (url, queryObj) => {
    let index = url.indexOf('?');
    let timespan = new Date().getTime(); // 获取当前时间戳
    url = (index == -1) ? (url + "?timespan=" + timespan) : (url + "&timespan=" + timespan); //判断是否url里面有没有传递的参数
    return http.get(url, {
      ...(queryObj || {})
    })
  },
  post: (url, data, queryObj) => {
    let index = url.indexOf('?');
    let timespan = new Date().getTime(); // 获取当前时间戳
    url = (index == -1) ? (url + "?timespan=" + timespan) : (url + "&timespan=" + timespan); //判断是否url里面有没有传递的参数
    return http.post(url, data || {}, {
      ...(queryObj || {})
    })
  }
}